import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'corporateFilter'
})
export class CorporateFilterPipe implements PipeTransform {

  transform(items: any[], isCorp: boolean) {
    return items.filter(i =>
    i.showInCorporate === 'both' || (i.showInCorporate === 'corporate' && isCorp)
  );
  }

}
